import type { FormHTTPMethodType } from '@/services/cms/getCMSForm/schema';
import { FormAPIError } from './FormAPIError';

interface CMSFormSubmit {
  url: string;
  method: FormHTTPMethodType;
  body: unknown;
}

export const cmsFormSubmit = async ({ url, method, body }: CMSFormSubmit) => {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const contentType = response.headers.get('Content-Type');
    const isContentTypeJSON =
      contentType && contentType.includes('application/json');

    if (!response.ok && isContentTypeJSON) {
      const errorDetails = await response.json(); // Parse error details
      throw new FormAPIError(response.status, errorDetails.errors);
    }

    if (!response.ok) {
      throw new Error(`HTTP Error ${response.status}: Not a valid json`);
    }

    return;
  } catch (error) {
    //TODO: log to sentry
    console.error('Error submission:', error);
    throw error;
  }
};
